import { initializeApp } from 'firebase/app';
import { getFirestore, collection, setDoc, doc, getDoc } from 'firebase/firestore';
import Cookies from 'js-cookie';
import generateUUID from '../utils/generateUUID';

const firebaseConfig = {
  apiKey: 'AIzaSyDOAD28wHowbGCQiBXXXSuyxLoww_vlCQY',
  authDomain: 'aircovent-77b53.firebaseapp.com',
  projectId: 'aircovent-77b53',
  storageBucket: 'aircovent-77b53.appspot.com',
  messagingSenderId: '21503318142',
  appId: '1:21503318142:web:e8ec580c3e64a433bba02f',
  measurementId: 'G-WXECRQZHP1'
};

const USER_COLLECTION_NAME = 'users';
const LOCALSTORAGE_ITEM_ID = 'fire-id';
const CUSTOM_SHOPPING_CART_EVENT = 'shopping-cart-updated-event';
const CUSTOM_SHOPPING_CART_PAGE_EVENT = 'shopping-cart-page-event';

const PageCodes = {
  LANDING_PAGE: 1,
  PRODUCT_OVERVIEW: 2,
  PRODUCT_DETAIL: 3,
  SHOPPING_CART: 4,
  SHOPPING_CART_DELIVERY: 5,
  SHOPPING_CART_PAYMENT: 6,
  SHOPPING_CART_PAID: 7
};

class FunnelActivityPusher {
  constructor() {
    this.app = initializeApp(firebaseConfig);
    this.db = getFirestore(this.app);
    this.cartTimer = null;

    // init user obj
    this.user = {
      name: '',
      email: '',
      cartId: '',
      userId: '',
      pageUrl: '/',
      pageCode: ''
    };
  }

  handleListener(event) {
    if (this.user.pageCode === PageCodes.SHOPPING_CART_PAID.toString()) {
      return;
    }

    const cartItems = (event && event.detail && event.detail.cart && event.detail.cart.items) || [];

    const items = cartItems.map(x => ({
      name: x.description,
      priceIncl: x.priceInclVat,
      priceExcl: x.price,
      quantity: x.quantity
    }));

    this.createOrUpdateDoc({ cart: items });
  }

  handlePageListener(event) {
    if (this.user.pageCode === PageCodes.SHOPPING_CART_PAID.toString()) {
      return;
    }

    const urlObj = FunnelActivityPusher.handleCheckoutPage(event.detail.pathname);

    this.createOrUpdateDoc({ pageCode: urlObj.pageCode, pageUrl: urlObj.url });
  }

  static handleCheckoutPage(urlPart) {
    let url = window.location.pathname;
    let pageCode = window.PAGE_CODE;
    if (window.PAGE_CODE === PageCodes.SHOPPING_CART.toString()) {
      switch (urlPart) {
        case '/cart':
          pageCode = PageCodes.SHOPPING_CART.toString();
          url = '/winkelwagen';
          break;
        case '/delivery':
          pageCode = PageCodes.SHOPPING_CART_DELIVERY.toString();
          url = '/winkelwagen#/delivery';
          break;
        case '/payment':
          pageCode = PageCodes.SHOPPING_CART_PAYMENT.toString();
          url = '/winkelwagen#/payment';
          break;
        default:
          pageCode = PageCodes.SHOPPING_CART.toString();
          url = '/winkelwagen';
          break;
      }
    }
    return { url, pageCode };
  }

  async init() {
    const urlObj = FunnelActivityPusher.handleCheckoutPage(window.location.hash.replace('#', ''));
    this.user.userId = window.USER_ID;
    this.user.name = window.USER_NAME;
    this.user.email = window.USER_EMAIL;
    this.user.pageCode = urlObj.pageCode;
    this.user.pageUrl = urlObj.url;
    this.user.cartId = Cookies.get('cartId');

    this.createOrUpdateDoc(this.user);

    window.addEventListener(CUSTOM_SHOPPING_CART_EVENT, this.handleListener.bind(this));
    window.addEventListener(CUSTOM_SHOPPING_CART_PAGE_EVENT, this.handlePageListener.bind(this));
  }

  async createOrUpdateDoc(data) {
    const usersCollection = collection(this.db, USER_COLLECTION_NAME);

    if (
      window.location.host.includes('beta') ||
      window.location.host.includes('pangaeatest') ||
      // window.location.host.includes('pangaeacms') ||
      window.location.host.includes('localhost')
    ) {
      return;
    }

    try {
      let docId = localStorage.getItem(LOCALSTORAGE_ITEM_ID);
      if (!docId) {
        docId = generateUUID();
        localStorage.setItem(LOCALSTORAGE_ITEM_ID, docId);
      }
      const currentDOc = await getDoc(doc(usersCollection, docId));

      const newData = {
        ...data,
        updatedAt: new Date()
      };

      if (!currentDOc.exists()) {
        newData.createdAt = new Date();
        newData.inStepSince = new Date();
        newData.cart = [];
      } else if (data.pageCode && data.pageCode !== currentDOc.data().pageCode) {
        newData.inStepSince = new Date();
        newData.cart = currentDOc.data().cart || [];
      } else if (!newData.cart && currentDOc.data().cart.length <= 0) {
        newData.cart = currentDOc.data().cart || [];
      }

      await setDoc(doc(usersCollection, docId), newData, { merge: true });
    } catch (error) {
      console.error(error);
    }
  }
}

export default FunnelActivityPusher;
